import { jsx as _jsx } from "react/jsx-runtime";
import { Select } from "@neru/ui";
import { useCurrentRegion } from "../../hooks";
import { RegionsManager } from "../../services";
export var RegionSelector = function(param) {
    var width = param.width;
    var _this;
    var regionsManager = new RegionsManager();
    var currentRegion = regionsManager.currentRegion, regions = regionsManager.regions;
    var region = useCurrentRegion();
    return /*#__PURE__*/ _jsx(Select, {
        "data-testid": "region-selector",
        defaultValue: (_this = region || currentRegion) === null || _this === void 0 ? void 0 : _this.alias,
        disabled: regions.length <= 1,
        items: regions.map(function(param) {
            var alias = param.alias, name = param.name;
            return {
                name: name !== null && name !== void 0 ? name : alias,
                value: alias
            };
        }),
        onChange: function(alias) {
            return regionsManager.currentRegionAlias = alias;
        },
        width: width
    });
};

//# sourceMappingURL=RegionSelector.js.map